module.exports = __webpack_public_path__ + "img/AI.65c5d86e.png";